var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-x-hidden absolute -inset-4 bg-white"},[_c('iframe',{staticClass:"block border-0",staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }